export default "__VITE_ASSET__BZ64jOYk__"